import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const FilterIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => {
  // TODO use css for this
  const { stroke = '#183558' } = props;

  return (
    <svg
      className="filter-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M11 11C11 12.1046 11.8954 13 13 13C14.1046 13 15 12.1046 15 11C15 9.89543 14.1046 9 13 9C11.8954 9 11 9.89543 11 11Z"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M1 5C1 6.10457 1.89543 7 3 7C4.10457 7 5 6.10457 5 5C5 3.89543 4.10457 3 3 3C1.89543 3 1 3.89543 1 5Z"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M1 11L11 11L1 11Z"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 5L15 5L5 5Z"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default FilterIcon;
